<template>
  <div class="edmodo-footer-column fl">
    <h4 class="widget-title" v-text="title"></h4>
    <nav>
      <ul>
        <li v-for="(link, index) in links" :key="index">
          <a :href="link.url + (lang ? ('?lang=' + lang) : '')" @click="eventTracking(link)" target="_blank">
            <span class="link-text" v-text="link.title"></span>
            <span class="arrow"></span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
const queryString = require('query-string')

export default {
  data () {
    return {
    }
  },
  computed: {
    lang () {
      let lang = ''
      try {
        const parsed = queryString.parse(location.hash.split('?')[1])
        lang = parsed.lang || ''
      } catch (e) {
        lang = ''
      }
      return lang
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    links: {
      type: Array,
      required: true
    }
  },
  mounted () {

  },
  methods: {
    init () {

    },
    eventTracking (link) {
      const { event_id, title } = link
      if (event_id && window.gtag) {
        window.gtag('event', event_id, {
          event_category: title,
          event_label: 'enter',
          from: this.$route.name,
          event_callback: () => {
            console.log({
              event_id,
              from: this.$route.name
            })
          }
        })
      }
    }
  },
  components: {}
}
</script>

<style scoped>
.edmodo-footer-column {
  padding-right: 15px; /*no*/
  padding-left: 15px; /*no*/
  margin-top: 74px; /*no*/
  width: 16.5%;
}
li {
  line-height: 38px; /*no*/
  height: 38px; /*no*/
}
.widget-title {
  color: #636466;
  margin: 0;
  padding: 0 10px 16px 20px; /*no*/
  font-size: 16px; /*no*/
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  font-family: "VulfSans"
}
a:first-child {
  padding-top: 0;
}
a {
  border-bottom: 1px solid transparent; /*no*/
  border-right-color: transparent;
  padding: 8px 0; /*no*/
  display: block;
  font-size: 14px; /*no*/
  color: #636466;
  font-family: "Disclaimer" !important;
  font-weight: 400;
  letter-spacing: 0px;
  font-style: normal;
  height: 100%;
  display: block;
  line-height: 30px; /*no*/
  padding-right: 10px; /*no*/
  padding-left: 20px; /*no*/
}
.link-text {
  font-size: 14px; /*no*/
  line-height: 30px; /*no*/
  display: block;
}
.arrow {
  padding-right: 0;
  width: 40px; /*no*/
  text-align: right;
  display: none;
  vertical-align: middle;
}
a:hover {
  text-decoration: underline;
}
ul {
  font-size: 12px; /*no*/
}
@media only screen and ( max-width: 768px) {
  .edmodo-footer-column {
    flex: 1;
    padding-right: 0px;
    padding-left: 7px;
    margin-top: 74px;
    width: auto;
  }
  li {
    line-height: 38px;
    height: auto;
  }
  /* li:nth-child(1) {
    line-height: 30px;
    height: 30px;
  } */
  .widget-title {
    color: #636466;
    margin: 0;
    padding: 0 0 16px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0px;
    font-family: "VulfSans"
  }
  a:first-child {
    padding-top: 0;
  }
  a {
    border-bottom: 1px solid transparent;
    border-right-color: transparent;
    padding: 8px 0;
    display: block;
    font-size: 14px;
    padding: 0 0 16px;
    color: #636466;
    font-family: "Disclaimer" !important;
    font-weight: 400;
    letter-spacing: 0px;
    font-style: normal;
    height: 100%;
    display: block;
    line-height: 30px;
  }
  .link-text {
    font-size: 14px;
    line-height: 23px;
    display: block;
  }
  .arrow {
    padding-right: 0;
    width: 40px;
    text-align: right;
    display: none;
    vertical-align: middle;
  }
  a:hover {
    text-decoration: underline;
  }
  ul {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// column.vue?34ffff61